function maskSpans(s: string, spans: [number, number][]): string {
    const chars = [...s];
    for (const [a, b] of spans) {
        for (let i = a; i < b; i++) {
            chars[i] = ' ';
        }
    }
    return chars.join('');
}

/**
 * VIN tokens from RO / name_po (same rules as backend NamePoVinUtils):
 * - 17 chars — full VIN (charset without I, O, Q).
 * - 8 chars — last-8 style: exactly 2 alphanumeric + 6 digits (first two may be letters or digits).
 * Дальнейшая проверка на бэкенде / в корзине — только если найден один из этих токенов.
 */
export function extractNamePoVins(text: string | null | undefined): string[] {
    if (!text?.trim()) {
        return [];
    }
    const upper = text.toUpperCase();
    const seen = new Set<string>();
    const ordered: string[] = [];
    const spans17: [number, number][] = [];

    const re17 = /(?<![A-HJ-NPR-Z0-9])([A-HJ-NPR-Z0-9]{17})(?![A-HJ-NPR-Z0-9])/g;
    let m: RegExpExecArray | null;
    while ((m = re17.exec(upper)) !== null) {
        if (!seen.has(m[1])) {
            seen.add(m[1]);
            ordered.push(m[1]);
        }
        spans17.push([m.index, m.index + m[0].length]);
    }

    const masked = maskSpans(upper, spans17);
    /** 2× [A–Z0–9] + 6× digit; границы, чтобы не вытягивать лишние цифры. */
    const re8 = /(?<![A-Z0-9])([A-Z0-9]{2}[0-9]{6})(?![0-9])/g;
    while ((m = re8.exec(masked)) !== null) {
        if (!seen.has(m[1])) {
            seen.add(m[1]);
            ordered.push(m[1]);
        }
    }
    return ordered;
}

/** Last 8 characters of VIN for backend match (or full string if shorter). */
export function vinMatchKey(vin: string): string {
    const v = vin.toUpperCase();
    if (v.length >= 8) {
        return v.slice(-8);
    }
    return v;
}
